import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";

import { ThemeProvider } from "@gately/ui/theme";
import { Toaster } from "@gately/ui/toast";

import type { orpc } from "~/lib/orpc";
import { LocaleProvider } from "~/lib/locale";

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
  orpc: typeof orpc;
}>()({
  component: RootComponent,
});

function RootComponent() {
  return (
    <ThemeProvider>
      <LocaleProvider>
        <Outlet />
        <Toaster />
        {import.meta.env.DEV ? (
          <TanStackRouterDevtools position="bottom-right" />
        ) : null}
      </LocaleProvider>
    </ThemeProvider>
  );
}
